import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");

var StudentAvatar = require("components/avatars/StudentAvatar");
var Board = require("components/utility/Board");
var Carousel = require("components/utility/Carousel");
var Spinner = require("components/utility/Spinner");
var TextAreaMarkups = require("components/writing/evaluations/TextAreaMarkups");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var AssignTaskModal = require("components/writing/tasks/AssignTaskModal");

var RubricRadarGraph = require("components/data/graphs/RubricRadarGraph")

var Features = require('lib/account/Features');
var PaywallLink = require("components/users/teachers/PaywallLink");
var ReactionFeedback = require("components/support/ReactionFeedback");
var Modal = require("components/utility/AltModal");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingActions = require('lib/actions/WritingActions');
var WritingSelectors = require('lib/selectors/WritingSelectors');

const INDIVIDUAL_VIEW = 'individual-view';
const GROUP_VIEW = 'group-view';
const COMPARISON_VIEW = 'comparison-view';
const PROGRESS_VIEW = 'progress-view';

import {STUDENT, STUDENT_LIST } from "components/data/graphs/GraphUtility"
import _ from "underscore";

require("data/teacher_insights_page.scss")

@connect(
	(state, props) => ({
		user: CurrentUser.get(),
		activities: WritingSelectors.getMostRecentActivities({ state, withAssigned: true }) || [],
		studentLists: RosterSelectors.studentLists({ state, embeds: ["student_list.students", "student.avatar", "student.prefs", "student.current_reading_level"]}),
	}),
	(dispatch, props) => ({
		fetchActivities: function (attr) {
			const { filters, conditions, embeds, page, cache } = attr;
			return dispatch(WritingActions.fetchActivities({
				filters, conditions, embeds, page, cache
			}))
		},
		fetchStudentLists: function () {
			return dispatch(RosterActions.fetchStudentLists({
				embeds: ["student_list.students", "student.avatar","student.prefs", "student.current_reading_level"]
			}))
		},
		fetchStudentList: function (id) {
			return dispatch(RosterActions.fetchStudentList({
				id: id, 
				embeds: ["student_list.students", "student_list.grade_level", "student.avatar", "student.prefs", "student.student_list.primary_admin", "student.perks"]
			}))
		},
		fetchStudent: function (id) {
			return dispatch(RosterActions.fetchStudent({
				id: id,
				embeds: ["student.avatar", "student.prefs", "student.current_reading_level"]
			}))
		},
		clearActivities: () => dispatch(WritingActions.clearActivities()),

		populateData: () => {
			// TODO: standardize FE requests
			return dispatch((dispatch, getState) => {
				var userIDs = _.pluck(RosterSelectors.students({ state: getState() }), "id")
				if ($wr.isLargeRequest(props.userIDs)) {
					var actionFunction = WritingActions.fetchTasks
					var options = { filters: { subject_type: "exercise" }, query: { completed: false }, cache: true }
					return new Promise(function (resolve, reject) {
						$wr.handleLargeRequest(dispatch, userIDs, {}, actionFunction, options, (results) => {
							resolve(results)
						})
					}).catch(() => console.log("Tasks failed to load"))
				} else {
					return dispatch(WritingActions.fetchTasks({
						filters: { subject_type: "exercise" },
						query: { completed: false },
						cache: true
					}))
				}
			})
		},
	})
)

@providePopulateData({ waitForLoad: true })
class SkillsetsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.assignTaskModal = React.createRef();
		if ($wr.getURLParameterByName("view")) {
			var initialView = $wr.getURLParameterByName("view");
		} else {
			var initialView = INDIVIDUAL_VIEW
		}

		this.state = {
			currentView: initialView,
			studentLists: props.studentLists || null, activeStudentList: {},
			activeStudent: null,
			exercisesByParams: {}, activityToAssignID: null,
			selectedActivityTitle: "",
			activeAttributeIndex: null, activeTypeKey: "weak",
			activeIndividualData: null, activeGroupData: null
		};
	}

	selectAttribute(activeTypeKey, attributeIndex, e) {
		$wr.nope(e);
		this.setState({ activeTypeKey: activeTypeKey, activeAttributeIndex: attributeIndex }, this.fetchActiveExercises);
	}

	assignActivity(activity) {
		this.setState({ activityToAssignID: activity.id, 
			selectedActivityTitle: activity.format_summary.title  }, () => {
			if (this.refs.assignTaskModal) {
				this.refs.assignTaskModal.show();
			}
		});
	}
	hideModal(selectedUserIDs, showNextModal) {
		this.refs.assignTaskModal.hide()
	}

	dividerWithTitle(titleText) {
		return (
			<div className="dividerWithTitle">
				<div className="dividerArea"></div>
				<div className="titleArea">
					{ titleText }
				</div>
			</div>
		);
	}

	isIndividualView() {
		return this.props.entityType == STUDENT
	}
	isGroupView() {
		return this.props.entityType == STUDENT_LIST;
	}

	getActiveAttributeData() {
		var data = this.isIndividualView() ? this.state.activeIndividualData : this.state.activeGroupData;
		if (data && data[this.state.activeTypeKey]) {
			return data[this.state.activeTypeKey][this.state.activeAttributeIndex];
		}

		return null;
	}

	showEmptyState() {
		var data = (this.isIndividualView()) ?
			this.state.activeIndividualData : this.state.activeGroupData;

		if (data) {
			return ((data["weak"] || []).length == 0) && ((data["strong"] || []).length == 0);
		}

		return false;
	}

	attributeListDisplay(attributeKey) {
		if (this.isIndividualView()) {
			var data = this.state.activeIndividualData;
		} else {
			var data = this.state.activeGroupData;
		}
		var attributeList = data[attributeKey];

		if (!attributeList || (attributeList.length == 0)) {
			var emptyText = "We don't have enough data yet to report on ";
			if (this.isIndividualView()) {
				emptyText += this.props.entity.first_name + "'s ";	
			} else {
				emptyText += " this class' "
			}

			if (attributeKey == "weak") {
				emptyText += "weaknesses.";
			} else {
				emptyText += "strengths.";
			}
			return (
				<p className="colEmpty">{ emptyText }</p>
			);
		}

		if (attributeKey == this.state.activeTypeKey) {
			var selAttributeTag = this.getActiveAttributeData().key;			
		} else {
			var selAttributeTag = undefined;
		}

		var attributesDisplay = _.map(attributeList, (attribute, index) => {
			var attributeClass = "attributeRow";
			var nextIndex = index + 1;
			if (attribute.key == selAttributeTag) {
				attributeClass += " selectedAttribute";
			} else if (attributeList.length > nextIndex && attributeList[nextIndex].key == selAttributeTag) {
				attributeClass += " beforeSelectedAttribute";
			}

			if (this.isIndividualView()) {
				var scoreLine = (
					<span className="attributeScore">
						{ attribute.count } { $wr.pluralize("time", attribute.count) }
					</span>
				);
			} else {
				var scoreLine = (
					<span className="attributeScore">
						{ attribute.count }/{ attribute.total } students
					</span>
				);
			}

			return (
				<a className={ attributeClass } key={ attribute.tag } href="#"
					onClick={ this.selectAttribute.bind(this, attributeKey, index) }>
					<span className="attrName ellipsisText">{ attribute.title }</span>
					{ scoreLine }
				</a>
			);
		});

		return (
			<div>
				{ attributesDisplay }
			</div>
		);
	}

    // creates the strengths + weaknesses part
	renderIndividualObservationsDisplay() {
		if (this.showEmptyState()) {
			var studentName = this.props.entity.first_name;
			if (!Features.isEnabled(Features.DIGITAL_EXERCISES)) {
				var paywallSection = (<PaywallLink featureLocation={ PaywallLink.INSIGHTS } />)
			}
			var displayContent = (
				<div>
					<EmptyStateContainer statusText={ "There isn't enough data yet to report on " + studentName + "'s strengths and weaknesses." }
						imagePath={ require("empty-state/insights-individual.png") } />	
					{ paywallSection }	
				</div>
				
			);
		} else {
			var displayContent = (
				<div className="row">
					<div className="col-sm-6">
						<h3>Weaknesses</h3>
						{ this.attributeListDisplay("weak") }
					</div>
					<div className="col-sm-6">
						<h3>Strengths</h3>
						{ this.attributeListDisplay("strong") }
					</div>
				</div>
			)

			if (this.getActiveAttributeData()) {
				var descriptionText = FeedbackFormatter.formatSimple(this.getActiveAttributeData().description,
					{ "firstName": this.props.entity.first_name });
				var description = (
					<p className="itemDescription">{ descriptionText }</p>
				);
			}
		}

		var radarGraph = this.renderComparisonDisplay()

		return (
			<div className="individualObservations">
				{ radarGraph }	
				{ displayContent }
				{ description }
			</div>
		);
	}

	renderGroupObservationsDisplay() {
        var attributeLists = (
            <div className="row">
                <div className="col-sm-6">
                    <h3>Weaknesses</h3>
                    { this.attributeListDisplay("weak") }
                </div>
                <div className="col-sm-6">
                    <h3>Strengths</h3>
                    { this.attributeListDisplay("strong") }
                </div>
            </div>
        )
		var attributeData = this.getActiveAttributeData();

		var students = $wr.sortByName(this.props.entity.students, "flexName");

		if (attributeData != undefined) {
			var studentNameDisplays = _.compact(_.map(students, (student) => {
				if (_.includes(attributeData.user_ids, student.id)) {
					return (
						<div className="nameAvatarDisplay" key={ student.id }>
							<StudentAvatar disableAnimation student={ student } maxWidth={ 50 } />
							<span className="studentName ellipsisText">{ student.display_name }</span>
						</div>
					);
				}
			}));
			var description = FeedbackFormatter.formatSimple(this.getActiveAttributeData().description,
			{ "firstName": "This group" });

			var examples = this.renderExampleCarousel(attributeData.examples, true)
		}

		var radarGraph = this.renderComparisonDisplay()


		return (
			<div className="groupObservations">
				{ radarGraph }
                { attributeLists }
				<p className="itemDescription">{ description }</p>
				{ studentNameDisplays }

				{ this.dividerWithTitle("Examples") }
				{ examples }
			</div>
		);
	}

	renderExampleCarousel(examples, showStudent) {
		examples = _.select(examples, (example) => example.answer )
		var exampleDisplays = _.map(examples, (example) => {
			var answer = example.answer;
			var answerDetailsClassName = "answerDetails";
			if (showStudent) {
				var student = _.find(this.state.activeStudentList.students, (student) => {
					return student.id == answer.user_id;
				});
				if (student) {
					answerDetailsClassName += " withStudent";
					var studentDisplay = (
						<div className="nameAvatarDisplay">
							<StudentAvatar disableAnimation student={ student } maxWidth={ 40 } />
							<span className="studentName ellipsisText">{ student.first_name }</span>
						</div>
					);
				}
			}
			return (
				<div key={ answer.id } className="singleExample">
					{ studentDisplay }
					<p className={ answerDetailsClassName }>
						<i>{ answer.text.title }</i>, { answer.text.author_full_name }<br />
						<span className="answerDate">{ $wr.formatDate(answer.completed_at) }</span>
					</p>

					<p><strong>{ answer.question_text }</strong></p>
					<TextAreaMarkups text={ example.corrected_answer } tagging={ example.tagging } />
				</div>
			);
		});

		return (
			<Carousel displayItems={ exampleDisplays }
				key={ this.state.activeTypeKey + this.state.activeAttributeIndex } />
		);

	}

	renderIndividualExamplesDisplay() {
		var activeData = this.getActiveAttributeData();
		if (!activeData) {
			return <div className="emptyExample" />
		}

		return (
			<div className="individualExamples">
				{ this.dividerWithTitle("Examples") }
				{ this.renderExampleCarousel(activeData.examples, false) }
			</div>
		);
	}

	renderExercisesDisplay() {
		var attributeData = this.getActiveAttributeData();

		if ((attributeData == undefined) || _.isEmpty(attributeData.exercise_params)) {
			return <div className="emptyExercises" />
		}
		// filter activities and display first 3
		var exercises = $wr.sortByName(this.props.activities, "flexName").splice(0, 3);
		
		if (this.isIndividualView()) {
			var previewParameters = { "assign_student_ids": this.props.entity.id }
			if (this.props.entity.prefs) {
				var gradeLevel = this.props.entity.prefs.academic_level;
			} else {
				var gradeLevel = null
			}
		} else {
			var previewParameters = { "assign_student_ids": attributeData.user_ids.join(",") }
			var gradeLevel = this.props.entity.grade_level;
		}

		if (exercises) {
			if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
				var recommendedExercises = (
					<Board type={ Board.TEACHER_ACTIVITIES } items={ exercises } narrowBoard={ true }
						previewParameters={ previewParameters }
						onItemAssign={ this.assignActivity } />
				);
			} else {
				var recommendedExercises = (
					<Board type={ Board.TEACHER_ACTIVITIES } items={ exercises } narrowBoard={ true }
						previewParameters={ previewParameters }
						onItemAssign={ this.showPaywall } onTileClick={ this.showPaywall } />
				);

			}
		} else {
			var recommendedExercises = (
				<Spinner placeholder={ true } scale={ 1.7 } />
			)
		}

		var exercisePagePath = "/exercises?grade_level=" + gradeLevel;
		if ("skillsets" in attributeData.exercise_params) {
			exercisePagePath += "&skillset=" + attributeData.exercise_params.skillsets;
		}

		if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
			var subheader = (
				<p className="exercisesSubheader">
					Assign these exercises focused on { attributeData.title },
					or <Link to={ exercisePagePath } target="_blank">find more here</Link>.
				</p>
			)
		} else {
			var subheader = (
				<p className="exercisesSubheader">
					Assign these online exercises focused on { attributeData.title } or
					print and hand them out in class.
				</p>
			)
		}

		return (
			<div className="exercises">
				{ this.dividerWithTitle("Exercises") }
				{ subheader }
				{ recommendedExercises }
			</div>
		);
	}

    renderComparisonDisplay(){
        if(this.showEmptyState()) {return}

        if(this.isIndividualView()){
            
            // find the student list that the student belongs to, so we can compare. 
            var studentList = _.find(this.props.studentLists, studentList=>{
                // students are attached to the student lists, but can either be a obj or id.
                return _.find(studentList.students, student=> (_.isEqual(student, this.props.entity) || student == this.props.entity.id))
            })
            
            var radarGraph = <RubricRadarGraph entity={this.props.entity} entityType={STUDENT} comparisons={[studentList]} comparisonType={STUDENT_LIST}/>

        } else {
            // dont want to be compared against itself
            var studentLists = _.filter([...this.props.studentLists], sl=>(sl.id != this.props.entity.id))
            var radarGraph = <RubricRadarGraph entity={this.props.entity} entityType={STUDENT_LIST} comparisons={studentLists} comparisonType={STUDENT_LIST}/>
        }
        
        return radarGraph
    }

	render() {
		if (!this.props.entity) {
			var rosterLink = "addNewStudentsButton=true";
			var emptyActionText = (
				<div>
					<p className="insightsEmptyText">
						It looks like you haven't added any students yet.
						<Link to={ "/roster?" + rosterLink }> Add students </Link> 
						and their strengths and learning gaps (<i>Insights</i>) will appear here!
					</p>
					<Link to={ "/roster?" + rosterLink }>
						<button className="btn buttonPrimary">Add Students</button>
		    		</Link> 
				</div>
			)

			var emptyImgPath = require("empty-state/insights-individual.png");
			var emptyState = (<EmptyStateContainer actionText={ emptyActionText }
				linkPath={ "/roster?" + rosterLink } imagePath={ emptyImgPath } sideBar={ true } />
			);
			return emptyState
		}

        var isLoading = (
            this.isIndividualView() && !this.state.activeIndividualData ||
            this.isGroupView() && !this.state.activeGroupData ||
            this.state.activeAttributeIndex == null
        )
		if (isLoading) {
			return (
				<div>
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);

		} else {
			if (this.isIndividualView()) {
				var observationsContent = this.renderIndividualObservationsDisplay();
				var examplesContent = this.renderIndividualExamplesDisplay();
			} else {
				if (this.showEmptyState()) {
					var observationsContent = (
						<EmptyStateContainer statusText={ "There isn't enough data yet to report on the strengths and weaknesses of these students." }
							imagePath={ require("empty-state/insights-group.png") } />
					);
				} else {
					var observationsContent = this.renderGroupObservationsDisplay();					
				}
			}
			var exercisesDisplay = this.renderExercisesDisplay()

			if (this.state.activityToAssignID) {

				if (this.isIndividualView()) {
					var studentIDs = [this.props.entity];
					var activeStudentList = this.state.activeStudentList
				} else {
					var studentIDs = this.getActiveAttributeData().user_ids;
				}

				var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";

				var assignTaskModal = (
					
					<Modal headerText={modalHeader} ref={ "assignTaskModal" }>
						<AssignTaskModal key={ this.state.activityToAssignID }
							selectedStudentIDs={studentIDs}
							renderAdditionalModal={true}
							taskSubjectType="exercise" 
							taskSubjectID={ this.state.activityToAssignID }
							studentLists={ activeStudentList } 
							selectedActivityTitle={ this.state.selectedActivityTitle } 
							onAssign={ this.hideModal } />
					</Modal>
				);
			}
		}

		return (
			<div className="container teacherInsightsPage">
				<div className="row">
					<div className="col-sm-9">
						{ observationsContent }
						{ examplesContent }
						{ exercisesDisplay }
					</div>
				</div>
				{ assignTaskModal }
			</div>
		);
	}

	componentDidMount() {
		this.fetchActiveData();

		$(window.document).on("standards-updated", this.onStandardsUpdate);
	}

	componentWillUnmount() {
		this._unmounted = true;
		$(window.document).off("standards-updated", this.onStandardsUpdate);
	}

	fetchActiveExercises() {
		if (this.getActiveAttributeData() == undefined) {
			return;
		}
		var exerciseParams = this.getActiveAttributeData().exercise_params;

		if (!exerciseParams) {
			return;
		}
		var paramsKey = JSON.stringify(exerciseParams);
		if (paramsKey in this.state.exercisesByParams) {
			return;
		}

		var params = _.pick(exerciseParams, "skillsets");

		params["embed"] = "activity.format_summary";
		params["grade_levels"] = CurrentUser.get().grade_level;
		params["sample"] = 3;
		// get relevant activities based on the student
		this.props
			.fetchActivities({
				page: null,
				embeds: ["activity.format_summary"],
				filters: params,
			}).then(response => {
				// set state's exercisesByParams basked on response
				var newExercisesByParams = _.clone(this.state.exercisesByParams);
				newExercisesByParams[paramsKey] = response.activities;
				this.setState({ exercisesByParams: newExercisesByParams });
			});
	}

	fetchActiveData() {
		this.setState({ activeIndividualData: null, activeGroupData: null,
			activeAttributeIndex: null, activeTypeKey: "weak" });
		if (this.isIndividualView()) {

			var params = {
				student_id: this.props.entity.id, embed: "example.answer,answer.text"
			}
			
            CurrentUser.api().getAnalyzeIndividualInsights(params, $wr.apiHandler((response) => {
                this.setState({ activeIndividualData: response.results, activeAttributeIndex: 0 }, this.fetchActiveExercises);
            }));
            

		} else if (this.isGroupView()) {
			var params = {
				student_list_id: this.props.entity.id, embed: "example.answer,answer.text"
			}
			CurrentUser.api().getAnalyzeGroupInsights(params, $wr.apiHandler((response) => {
				this.setState({ activeGroupData: response.results, activeAttributeIndex: 0 }, this.fetchActiveExercises);
			}));
		}
	}

    componentDidUpdate(prevProps){
        if (prevProps.entity != this.props.entity){
            this.fetchActiveData()
        }
    }
}


SkillsetsPage.propTypes = PageStrictPropTypes({
});

module.exports = SkillsetsPage;


// WEBPACK FOOTER //
// ./modules/components/data/SkillsetsPage.js